
import { useState, useEffect } from 'react';

interface ScrollProgress {
  scrollY: number;
  progress: number;
}

const useScrollProgress = (elementId: string) => {
  const [scrollProgress, setScrollProgress] = useState<ScrollProgress>({
    scrollY: 0,
    progress: 0
  });

  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById(elementId);
      if (!element) return;

      const rect = element.getBoundingClientRect();
      const elementTop = rect.top + window.scrollY;
      const elementHeight = rect.height;
      const currentScrollY = window.scrollY;
      const windowHeight = window.innerHeight;

      // Calculate progress when element is in view
      const startOffset = elementTop - windowHeight;
      const endOffset = elementTop + elementHeight;
      
      let progress = 0;
      if (currentScrollY > startOffset && currentScrollY < endOffset) {
        progress = Math.min(Math.max((currentScrollY - startOffset) / (endOffset - startOffset), 0), 1);
      } else if (currentScrollY >= endOffset) {
        progress = 1;
      }

      setScrollProgress({
        scrollY: currentScrollY,
        progress
      });
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial call
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [elementId]);

  return scrollProgress;
};

export default useScrollProgress;
